import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        field: '='
    },
    template: `
        <div class="well">
            <h2>{{ 'course.General data' | translate }}</h2>
            <form class="form" ng-submit="vm.save()">
                <form-wrapper form="vm.form">
                    <form-row error="vm.form.errors.value">
                        <label class="label">{{ 'course.Field name' | translate }} *</label>
                        <div class="items">
                            <input ng-model="vm.form.model.classifierI18ns[vm.defaultLanguage].value" type="text" class="form-control">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                </form-wrapper>
                <button type="submit" class="hidden" >{{ 'general.Save changes' | translate }}</button>
            </form>
        </div>
        <div ng-if="vm.form.model.id" ng-init="vm.initCourses()" class="well color02">
            <h2>{{ 'course.Courses' | translate }}</h2>
            <courses-courses-list-list list="vm.list"/>
        </div>
        <ul class="actions01">
            <li class="primary">
                <a ng-click="vm.save()" class="btn main">
                    <span ng-if="vm.form.model.id">{{ 'general.Save' | translate }}</span>
                    <span ng-if="!vm.form.model.id">{{ 'course.Add training field' | translate }}</span>
                </a>
            </li>
            <li>
                <a ui-sref="authorized.courses.fields.list()" class="btn discrete" >
                    <span ng-if="vm.form.model.id">{{ 'general.Back to list' | translate }}</span>
                    <span ng-if="!vm.form.model.id">{{ 'general.Cancel' | translate }}</span>
                </a>
            </li>
        </ul>
    `
})
export default class {
    constructor ($state, $translate, COURSE_STATUS_ENUM, ListFactory, TokenService, CourseResource, toastr) {
        this.COURSE_STATUS_ENUM = COURSE_STATUS_ENUM;
        this.$state = $state;
        this.$translate = $translate;
        this.list = ListFactory.createWithoutPagination(CourseResource.query.bind(CourseResource));
        this.toastr = toastr;
        this.TokenService = TokenService;
    }

    $onInit () {
        this.defaultLanguage = this.TokenService.getCompanyLanguage();

        if (!this.field.id) {
            this.form.model.classifierI18ns = {};
            this.form.model.classifierI18ns[this.defaultLanguage] = { value: '' };
        }
    }

    initCourses () {
        this.list.fetch({
            fieldId: this.field.id,
            status: this.COURSE_STATUS_ENUM.KEYS.COMPLETE,
            expand: 'activeI18n'
        });
    }

    beforeSave () {
        // course fields are coursy classifiers, so value should be also set
        this.form.model.value = this.form.model.classifierI18ns[this.defaultLanguage].value;
    }

    save () {
        this.beforeSave();
        this.form.save()
            .then((model) => {
                this.form.saved = false; // this is for avoiding duplicated success message through form wrapper, COUR-4308
                this.toastr.success(this.$translate.instant('general.Changes saved'));
                this.field = model;
                this.$state.go('authorized.courses.fields.detail', { id: model.id });
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/fields/form/index.js